export default __webpack_public_path__ + "img/feature_checkout.21841ea3.svg";